import React from 'react';
import clsx from 'clsx';
import { ICellProps } from 'shared/components/table/GridTable/GridTableModel';
import { TimeAndMoneyCell } from '../components/cells/abstract/TimeAndMoneyCell';
import { TableClasses } from '../model';
import { IGroupedSheetCalculationCommon } from 'modules/payrollProcessorHub/store/model';

type DoubleTimeHoursCellProps = ICellProps<IGroupedSheetCalculationCommon>;

export function makePslCell(tableClasses: TableClasses) {
    return function PslCell({
        className,
        time_psl_hours,
        time_psl_dollars,
    }: DoubleTimeHoursCellProps) {
        return (
            <TimeAndMoneyCell
                className={clsx(className, tableClasses.pullRight)}
                time={time_psl_hours}
                money={time_psl_dollars}
            />
        );
    };
}
